import * as React from 'react'
import { Provider as ReduxProvider } from 'react-redux'
import {
  getWidgetProps,
  WPSClient,
  Args,
  withArgs,
  Widget
} from '@utils'

import { requestWpsData } from '../../utils/requestWpsData'
import { configureStore } from '../../store'
import {
  normalizeGetDetailPage, NormalizeGetDetailPageType,
  normalizeGetStrings, NormalizeGetStringsType
} from '../../data/normalize'
import { IDetailPageState } from '../../reducers'
import { getAdditionalInput } from '../../data/getDetailPageInputs'
import { safeBoolean } from '../../utils/utils'
import { ErrorBoundary } from '../../components/error/ErrorBoundary'
import { AdditionalComponent } from './component'
import { DVUI } from '@amzn/dvui/dist/DVUI'
import { StringBundle } from '../../components/localizer/stringBundle'
import { DpWidgetContext } from '../../utils/dpWidgetContext'
import { buildGetString } from '../../utils/stringUtils'

export type AdditionalProps =  {
  state: NormalizeGetDetailPageType &
    Pick<IDetailPageState, 'features'>
} & NormalizeGetStringsType


export const getProps: getWidgetProps<AdditionalProps> = async ({ context, titleID, useFaq, useContactUs, useTabbedCastAndCrew }, api) => {
  const operation = (wpsClient: WPSClient) =>
      wpsClient.GetDetailPage(getAdditionalInput({ context, titleID }, safeBoolean(useFaq), safeBoolean(useContactUs)))

  const reply = await requestWpsData({
    context,
    api,
    operation,
    stringBundle: StringBundle.Additional
  })

  const features = {
    useFaq: safeBoolean(useFaq),
    useContactUs: safeBoolean(useContactUs),
    useTabbedCastAndCrew: safeBoolean(useTabbedCastAndCrew)
  }

  return {
    state: {
      features,
      ...normalizeGetDetailPage(titleID, reply.operationResponse),
    },
    ...normalizeGetStrings(reply.stringsResponse!),
  }
}

const AdditionalWidget = (props: AdditionalProps & Args) => {
  const {logger, state, context: requestContext, strings} = props
  const store = configureStore({...state, requestContext}, logger)
  return (
    <DVUI>
      <DpWidgetContext.Provider value={{ getString: buildGetString(strings, logger, requestContext) }}>
        <ReduxProvider store={store}>
          <ErrorBoundary name='additional'>
            <AdditionalComponent />
          </ErrorBoundary>
        </ReduxProvider>
      </DpWidgetContext.Provider>
    </DVUI>
  )
}

export const Additional: Widget<AdditionalProps> = {
  name: 'detail-additional',
  getProps: global.__SERVER__ === true ? getProps : undefined,
  Component: withArgs(AdditionalWidget) as React.ComponentType<any>
}
